export const navigateToWhatsapp = (phone: string): void => {
  window.open(`https://wa.me/${phone}`, "_blank");
};
